export { default } from "./getLanguageCode";
